import { openBlock as e, createElementBlock as t, createElementVNode as o } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, c = /* @__PURE__ */ o("path", { d: "m16.923 6.291-1.356 1.353a.948.948 0 0 0-.282.678.97.97 0 0 0 .072.369.94.94 0 0 0 .21.3l15 15-15 15a.945.945 0 0 0-.207.3.978.978 0 0 0-.075.369.94.94 0 0 0 .282.666l1.359 1.353a.96.96 0 0 0 1.353 0l17.7-17.7-17.721-17.7a.963.963 0 0 0-1.356 0l.02.012Z" }, null, -1), l = [
  c
];
function r(s, a) {
  return e(), t("svg", n, l);
}
const _ = { render: r };
export {
  _ as default,
  r as render
};
//# sourceMappingURL=chevron-right.svg.mjs.map
